import {
  concretiseParams,
  updateSearchParamsWithFilters,
} from "../filters/filters"
import { updateSearchParamsWithPagination } from "../../page"
import { API_BASE_URL } from "../../app/config"

/**
 * Get scheduled observations matching the filters
 * @param filers  // filters to apply
 * @param page  // pagination settings
 * @returns {Promise<any>}
 */
export const getScheduledObservations = async ({ filter = {}, page = {} }) => {
  // Build parameter set
  const params = new URLSearchParams()
  updateSearchParamsWithFilters(params, filter)
  // Replace any relative ones with absolute ones
  concretiseParams(params)
  // Pagination control
  updateSearchParamsWithPagination(params, page)

  const response = await fetch(
    `${API_BASE_URL}/api/schedules/observations?${params.toString()}`
  )
  if (!response.ok) {
    throw new Error(
      `HTTP error ${response.status} received when calling the getScheduledObservations service.`
    )
  }

  return response.json()
}

/**
 * Get scheduled observations stats for the matching the filters
 * @param filers  // filters to apply
 * @returns {Promise<any>}
 */
export const getScheduledObservationsStats = async ({ filter = {} }) => {
  // Build parameter set
  const params = new URLSearchParams()
  updateSearchParamsWithFilters(params, filter)
  // Replace any relative ones with absolute ones
  concretiseParams(params)

  const response = await fetch(
    `${API_BASE_URL}/api/schedules/observations/stats?${params.toString()}`
  )
  if (!response.ok) {
    throw new Error(
      `HTTP error ${response.status} received when calling the getScheduledObservationsStats service.`
    )
  }

  return response.json()
}

/**
 * Get scheduled observations stats for the last 7 days grouped by day
 * @returns {Promise<any>}
 */
export const getScheduledObservationsDailyStats = async ({ filter = {} }) => {
  // Build parameter set
  const params = new URLSearchParams()
  updateSearchParamsWithFilters(params, filter)
  // Replace any relative ones with absolute ones
  concretiseParams(params)
  const response = await fetch(
    `${API_BASE_URL}/api/schedules/observations/stats/daily?${params.toString()}`
  )
  if (!response.ok) {
    throw new Error(
      `HTTP error ${response.status} received when calling the getScheduledObservationsDailyStats service.`
    )
  }

  return response.json()
}
